// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"248":"component---src-templates-basic-route-innards-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"248":"d80e2dde0ec5133a694d","415":"b29ae0db1bfb1c79b41e","522":"7d3ef0b84cc50faa9e95"}[chunkId] + ".js";
};